import { useToast } from '@src/contexts/useToastContext';
import { useEffect } from 'react';

type ErrorToastProps = {
  message: string;
  onClose: () => void;
};

export const ErrorToast = ({ message, onClose }: ErrorToastProps) => {
  const toaster = useToast();

  useEffect(() => {
    const toastId = toaster?.add({
      message,
      type: 'error',
      onClose,
    });

    return () => {
      if (toastId) {
        toaster?.remove(toastId);
      }
    };
  }, [message, onClose, toaster]);

  return null;
};
